
export default
    name: 'toggle-comparison-button'
    props: ['bib', 'in_compare']
